var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3",attrs:{"justify":"center","align":"center"}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_c('v-spacer'),_c('span',[_vm._v(_vm._s(_vm.noDataText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }